import axios from "axios";
/* eslint-disable */
const state = {
  unreadNotifications: [],
  unreadAlerts: [],
};
let refreshTokenPromise = null;

const getters = {
  hasUnreadNotifications: state => state.unreadNotifications && state.unreadNotifications.length,
  hasUnreadAlerts: state => state.unreadAlerts && state.unreadAlerts.length,
  getUnreadAlertIDs: state => state.unreadAlerts.map(alert => alert.AlertID),
  getUnreadNotificationIDs: state => state.unreadNotifications.map(notification => notification.NotificationID),
};
const actions = {
  async getUnreadNotifications({commit, rootGetters, dispatch}) {
    const url = rootGetters.unreadNotifications;
    const response = await axios.get(url);
    await commit('setUnreadNotifications', response.data.Result);
  },
  async getUnreadAlerts({commit, rootGetters, dispatch}) {
    const url = rootGetters.unreadAlerts;
    const response = await axios.get(url);
    await commit('setUnreadAlerts', response.data.Result);
  },
  async setAlertViewed({commit, rootGetters, dispatch}, alertID) {
    const url = rootGetters.readAlert(alertID);
    const response = await axios.patch(url);
    dispatch('getUnreadAlerts');
  },
  async setNotificationViewed({commit, rootGetters, dispatch}, notificationID) {
    const url = rootGetters.readNotification(notificationID);
    const response = await axios.patch(url);
    dispatch('getUnreadNotifications');
  },
};
const mutations = {
  setUnreadNotifications(state, notifications) {
    state.unreadNotifications = notifications;
  },
  setUnreadAlerts(state, alerts) {
    state.unreadAlerts = alerts;
  },

};
export default {
  state,
  getters,
  actions,
  mutations
};